import { Subject } from "rxjs";
import { environment } from "../environments/environment";
import { BackStagePayload } from "./web-generator/template-generator/entity/back-stage-payload";
import { ServerConfigService } from "./share/service/server-config.service";
import { BackStageTemplateService } from "./share/service/back-stage-template.service";
import { isPlatformBrowser, LOCATION_INITIALIZED } from "@angular/common";
import { Injector, PLATFORM_ID } from "@angular/core";
import { LoggerService } from "./share/service/logger.service";
import { TranslateService } from "@ngx-translate/core";

export function initializationFactory(injector: Injector) {
  return () => new Promise<void>((resolve: () => void) => {
    const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
    const platformId = injector.get(PLATFORM_ID);
    const serverConfigService = injector.get(ServerConfigService);
    const loggerService: LoggerService = injector.get(LoggerService);
    const translate: TranslateService = injector.get(TranslateService);
    const backStageTemplateService = injector.get(BackStageTemplateService);
    const isBrowser = isPlatformBrowser(platformId);

    if (!isBrowser) {
      loggerService.info(`initializationFactory`);
    }
    locationInitialized.then(() => {
      if (!isBrowser) {
        loggerService.info(`locationInitialized`);
      }

      const backStageSubj = beforeFetchSiteInfo(isBrowser, serverConfigService, backStageTemplateService);
      serverConfigService.getConfig(backStageSubj).toPromise().then((config) => {
        if (config) {
          // 設定i18n
          translate.use(config.lang);
        }

        // TODO: 檢查有無資料(長度>1)
        // this.loggerService.error('server config 是空的');
        // navigateCrossPlatform(this.serverConfigService.isBrowser, this.router, this.response, ['/404']);

        resolve();
      });
    });
  });
}

/** 初始化取 siteInfo 前先判斷是否為編輯模式 */
function beforeFetchSiteInfo(isBrowser: boolean, serverConfigService: ServerConfigService, backStageTemplateService: BackStageTemplateService) {
  let backStageSubj: Subject<BackStagePayload>;
  if (isBrowser && serverConfigService.isEditModeUrl) { // 如果是編輯模式的 url，直接進 CSR 畫面
    const url = serverConfigService.url;
    const queryParamSatrtIndex = url.indexOf('?');
    const url2 = url.slice(0, queryParamSatrtIndex);
    const urlObj = new URL(url);
    const stageParam = urlObj.searchParams.get('stage');
    let stageUrl: string; // 'aHR0cCUzQSUyRiUyRmxvY2FsaG9zdCUzQTQzMDA='

    try {
      stageUrl = decodeURIComponent(atob(decodeURIComponent(stageParam)));
    } catch (e) {
      const obj = {
        url: serverConfigService.url,
        stageParam,
      };
      console.error(e, JSON.stringify(obj));
    }

    checkStageUrlAllowedAccess(stageUrl, url2);
    window.opener.postMessage('appInit', stageUrl);

    const url3 = url2.replace(/\/$/i, '').replace(/\.html/i, '') + '/';
    const urlSegs = url2.replace(/https?:\/\//g, '').split('/');
    const isIndexPage = urlSegs.length === 2;
    const isSubjectDetailPage = urlSegs.length === 4;
    backStageSubj = backStageTemplateService.listenOnWindowMessage(isIndexPage, isSubjectDetailPage);
  }

  return backStageSubj;
}

/** 檢查編輯模式中的 stageUrl 是否在白名單上允許存取 */
function checkStageUrlAllowedAccess(stageUrl: string, redirectUrl: string): void {
  const match = environment.allowBackStageDomain.find(domain => domain === stageUrl);

  const opener = window.opener;
  if (environment.production) {
    if (!opener || opener === window || !match || !stageUrl) {
      if (!opener) {
        console.error('no opener');
      } else if (opener === window) {
        console.error('open self');
      } else if (!match) {
        console.error('allowBackStageDomain not match');
      }

      alert('請從後台進入!');
      window.location.href = redirectUrl;
    }
  }
}
